import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import EnSelectField from 'Components/inputs/EnSelectField/EnSelectField.vue';
import { FilterEvent } from '../types/filterEvent';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnFilterTypeSelectButton',
    props: /*@__PURE__*/ _mergeModels({
        items: Array,
        id: String
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['update:modelValue', FilterEvent.Input,], ["update:modelValue"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const modelValue = _useModel(__props, 'modelValue');
        const emit = __emit;
        const selectId = computed(() => {
            if (props.id)
                return `en-filter-select-${props.id}`;
        });
        const selectedItem = computed({
            get() {
                return modelValue.value;
            },
            set(value) {
                emit(FilterEvent.Input, value);
                emit('update:modelValue', value);
            },
        });
        const __returned__ = { props, modelValue, emit, selectId, selectedItem, EnSelectField };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
